export const IArchiveItemInfo = {
  id: 4,
  name: 'Butter',
  last_user_id: 1,
  archived_at: '2024-03-07T14:41:05.551Z',
}

export const IArchive = {
  entity_type: 'inventory_item',
  list: [IArchiveItemInfo],
}
